module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.da4ea5c.ttf";